import { useMediaQuery } from "@react-hook/media-query";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { animateScroll as scroll } from "react-scroll";
import robert from "../../../src/Assests/trackright/Robert.svg";
import ritu from "../../../src/Assests/trackright/ritu.svg";
import neeru from "../../../src/Assests/trackright/neeru.svg";

export default function Contactbanner() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 100,
      smooth: "smooth",
    });
  };

  return (
    <>
      <BannerWrap>
        <Row id="ourteam_container">
          <Col xl={4}></Col>
          <Col xl={4}>
            <div className="container_eight">
              <p>Our Team</p>
            </div>
          </Col>
          <Col xl={4}></Col>

          <div className="container_seven">
            <div>
              <a
                href="https://www.linkedin.com/in/ritu-bahal-5a524053/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/ritu-bahal-5a524053/",
                      "_blank",
                    )
                  }
                  style={{ width: "400px" }}
                  src={ritu}
                  alt=""
                ></img>
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/in/neeru-maini-87019b8/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/neeru-maini-87019b8/",
                      "_blank",
                    )
                  }
                  style={{ width: "400px" }}
                  src={neeru}
                  alt=""
                ></img>
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/in/robert-mutwiri-michuki-a0053b7a/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{ width: "400px" }}
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/robert-mutwiri-michuki-a0053b7a/",
                      "_blank",
                    )
                  }
                  src={robert}
                  alt=""
                ></img>
              </a>
            </div>
          </div>
        </Row>
      </BannerWrap>

      <BannerWrap>
        <Container fluid className="pt-5 pb-5">
          <Row>
            <Col className={` ${isMobile ? "" : "contain-margin"}`}>
              {/* </Container> */}
            </Col>
          </Row>
          {/* <Row className="spacing">
            <Col xl={12}>
              <div className="spacing_one">
                <div class="banner">
                  <h1>
                    Are you looking for{" "}
                    <span class="highlight">personalized pricing</span> for your
                    organization?
                  </h1>
                  <p>We are here to help you!</p>
                  <button class="contact-btn">Contact Us</button>
                </div>
              </div>
            </Col>
          </Row> */}
          <Row>
            <div className="container_nine">
              <div class="pricing-card">
                <h2>
                  Are you looking for&nbsp;
                  <span>personalized pricing</span>&nbsp; for your organization?
                </h2>

                <p>We are here to help you!</p>

                <button
                  onClick={() => {
                    navigate("/Contact");
                  }}
                >
                  Contact Us
                </button>
              </div>
            </div>
          </Row>
        </Container>
      </BannerWrap>
    </>
  );
}

export const BannerWrap = styled.div`
  * {
    box-sizing: border-box;
    font-family: "Segoe UI", Arial, sans-serif;
  }

  body {
    background: #ffffff;

    padding: 80px 20px;
  }
  .container_nine {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pricing-card {
    width: 85% !important;
    padding: 50px 20px;
    text-align: center;
    border-radius: 24px;
    background: radial-gradient(circle at left center, #eaffea 0%, #ffffff 55%);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }

  .pricing-card h2 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .pricing-card h2 span {
    color: #2e7d32;
  }

  .pricing-card p {
    font-size: 16px;
    color: #444;
    margin-bottom: 22px;
  }

  .pricing-card button {
    background: #0a7d00;
    color: #fff;
    border: none;
    padding: 10px 28px;
    font-size: 15px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .pricing-card button:hover {
    background: #066400;
  }

  .container_eight {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 0px 25px 0px;
  }
  .container_eight > p {
    font-size: 39px;
    font-weight: 600;
  }
  #ourteam_container {
    background-color: rgb(244, 244, 244);
    padding-top: 90px;
    padding-bottom: 90px;
  }
  .container_seven {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 75px;
  }
  .spacing {
    margin-top: 20px;
  }
  .spacing_one {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    justify-content: center;
  }
  .banner {
    /* border-radius: 35px; */
    background: linear-gradient(
      to bottom,
      #e8f5e3 0%,
      #e8f5e3 95%,
      #fff 95%,
      #fff 100%
    );
    padding: 60px 40px;
    text-align: center;
    max-width: 1200px;
    width: 100%;
  }

  .banner h1 {
    font-size: 2.5rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
    line-height: 1.3;
  }

  .banner h1 .highlight {
    color: #2d8a3e;
  }

  .banner p {
    font-size: 1.25rem;
    color: #333;
    margin-bottom: 30px;
  }

  .contact-btn {
    background-color: #2d8a3e;
    color: white;
    font-size: 1rem;
    font-weight: 500;
    padding: 14px 40px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .contact-btn:hover {
    background-color: #236b30;
  }

  @media (max-width: 768px) {
    .banner {
      /* padding: 40px 20px; */
    }

    .banner h1 {
      font-size: 1.75rem;
    }

    .banner p {
      font-size: 1rem;
    }

    .contact-btn {
      padding: 12px 30px;
    }
  }

  .shadow-box {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 30px;
    background-color: white;
    text-align: center;
    /* background: linear-gradient(10deg, #2d53da, white); */
    background: rgb(217, 215, 255);
    background: linear-gradient(
      45deg,
      rgba(217, 215, 255, 1) 0%,
      rgba(255, 255, 255, 1) 45%,
      rgba(255, 255, 255, 1) 100%
    );
  }

  .text1 {
    font-size: 36px;
    font-weight: 700;
    color: black;
  }

  .text2 {
    font-size: 20px;
    font-weight: 400;
    color: #1f243b;
  }

  .text1-mob {
    font-size: 20px;
    font-weight: 700;
    color: #2d53da;
  }

  .custom-shape-divider-top-1713586688 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(90deg);
  }

  .custom-shape-divider-top-1713586688 svg {
    position: relative;
    display: block;
    width: calc(184% + 1.3px);
    height: 112px;
  }

  .custom-shape-divider-top-1713586688 .shape-fill {
    fill: #a1b2cd;
  }
`;
